import axios from "axios";
import { extractTiposIdentificacion } from "../utils/tiposIdentificacion";

const toArray = <T,>(value: T | T[] | undefined | null): T[] => {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
};

const normalizeLineasCreditoResponse = (data: any) => {
    const listLineaCredito = data?.payload?.data?.ListLineaCredito;
    if (!listLineaCredito || listLineaCredito.Datos_LineasCredito) {
        return data;
    }

    const items = toArray(listLineaCredito.LineaCreditoDTO);
    listLineaCredito.Datos_LineasCredito = items.map((item: any) => ({
        s_codigo: String(item.ICodigo ?? item.iCodigo ?? item.s_codigo ?? ''),
        s_nombre: item.SDescripcion ?? item.sDescripcion ?? item.s_nombre ?? '',
        s_rotativo: item.s_rotativo ?? item.SRotativo ?? false,
    }));

    return data;
};

const normalizeTiposIdentificacionResponse = (data: any) => {
    const tipos = extractTiposIdentificacion(data);
    if (tipos.length === 0) {
        return data;
    }

    const lstTiposIdent = data?.payload?.data?.LstTiposIdent;
    if (lstTiposIdent) {
        lstTiposIdent.Datos_TiposIdentificacion = tipos;
    }

    return data;
};

const mapPeriodoItem = (item: any) => {
    const descripcion = item.SDescripcion ?? item.sDescripcion ?? item.s_descripcion ?? '';
    return {
        s_codigo: String(item.ICodigo ?? item.iCodigo ?? item.s_codigo ?? ''),
        s_descripcion: descripcion,
    };
};

const normalizePeriodosResponse = (data: any) => {
    const listPerido = data?.payload?.data?.ListPerido;
    if (!listPerido) {
        return data;
    }

    if (!listPerido.Datos_Periodo && listPerido.PeriodoDTO) {
        const items = toArray(listPerido.PeriodoDTO);
        listPerido.Datos_Periodo = items.map(mapPeriodoItem);
    } else if (Array.isArray(listPerido.Datos_Periodo)) {
        listPerido.Datos_Periodo = listPerido.Datos_Periodo.map(mapPeriodoItem);
    }

    return data;
};

export class AdminService {
    static async getCargos(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+`/admin/cargos`);
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async getOcupaciones(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+`/admin/ocupaciones`);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async getTipoContrato(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+'/admin/tipocontrato');
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async getColors(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+'/admin/colors');
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async addColors(colors: any): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API+'/admin/colors', colors);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async getUsuarios(valor: {
        Pws_Tip_Estado: string
    }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API+'/requests/solicitudpersonas', valor);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async gettipoidentificacion(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+'/admin/tipoidentificacion');
            return normalizeTiposIdentificacionResponse(data);
        } catch (e) {
            throw e;
        }
    }

    static async getTiposIdentificacionList() {
        const response = await AdminService.gettipoidentificacion();
        return extractTiposIdentificacion(response);
    }

    static async getOficinas(): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API+'/admin/oficinas');
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async getlineascredito(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+'/admin/lineascredito');
            return normalizeLineasCreditoResponse(data);
        } catch (e) {
            throw e;
        }
    }
    static async getPeriodos(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+'/admin/periodos');
            return normalizePeriodosResponse(data);
        } catch (e) {
            throw e;
        }
    }
    static async gettipovivienda(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+'/admin/tipovivienda');
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async getNivelEstudio(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+'/admin/nivelestudio');
            return data;
        } catch (e) {
            throw e;
        }
    }
    
    static async getEstadosCiviles(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+'/admin/estadosciviles');
            return data;
        } catch (e) {
            throw e;
        }
    }
    
    static async getCiudadesByUbicacion(ubicacion: string): Promise<any> {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_API}/admin/ciudades?s_nivel=3&s_ubicacion=${ubicacion}`);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async getCiudades(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+'/admin/ciudades?s_nivel=3');
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async getAllCiudades(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+'/admin/ciudades');
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async getDepartamentos(): Promise<any> {
        try {
            // Panamá = 139 (nivel 1). Provincias = nivel 2 con ubicación del país.
            const { data } = await axios.get(process.env.REACT_APP_API+'/admin/ciudades?s_nivel=2&s_ubicacion=139');
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async getDistritosByProvincia(ubicacion: string): Promise<any> {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_API}/admin/ciudades?s_nivel=3&s_ubicacion=${ubicacion}`);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async getCorregimientosByDistrito(ubicacion: string): Promise<any> {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_API}/admin/ciudades?s_nivel=4&s_ubicacion=${ubicacion}`);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async entidadTer(i_codigo:String): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API+'/admin/entidadter', i_codigo);
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async getEntidadFin():Promise <any>{
        try{
            const { data } = await axios.post(process.env.REACT_APP_API+'/admin/entidadesfin');
            return data;
        }catch(e) {
            throw e;
        }
    }
    static async getSucursal(sucursalRequest: { s_nombre: string }): Promise<any> {
        try {
            const { data } = await axios.post(`${process.env.REACT_APP_API}/admin/sucursal`, sucursalRequest);
            return data;
        } catch (e) {
            throw e;
        }
    }
    
    static async getListaEstado(i_codigo:String): Promise<any>{
        try {
            const { data } = await axios.post(process.env.REACT_APP_API+'/admin/estados', i_codigo)
            return data
        } catch (e) {
            throw e;
        }
    }


    
    static async getProfesiones(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+'/admin/profesiones');
            return data;
        } catch (e) {
            throw e;
        } 
    }

    static async getReferencias(): Promise<any> {
        try {
            const { data } = await axios.get(process.env.REACT_APP_API+'/admin/referencias');
            return data;
        } catch (e) {
            throw e;
        } 
    }
}